// Carbon6 Hub routes. The platform guide fixes these paths; only the base URL varies per environment.
import { HUB_URL } from '../config/api'

const hubUrl = (path, returnTo) => (
  `${String(HUB_URL).replace(/\/+$/, '')}${path}?${new URLSearchParams({ returnTo })}`
)

// returnTo must be an absolute URL on an origin the Hub allows.
export const onboardingUrl = (returnTo = window.location.href) => (
  hubUrl('/api/onboarding/enter', returnTo)
)

// Hub logout signs out everywhere, then Cognito sends the browser back to returnTo.
export const logoutUrl = (returnTo = window.location.origin) => (
  hubUrl('/api/cognito-auth/logout', returnTo)
)
